import { MedForm, createEmptyMedForm } from './medForm';

class Metadata {
  name = '';
  EHPADName = '';
  EHPADPhone = '';
  IDEName = '';
  IDEADELI = '';
  dentistName = '';
  dentistRPPS = '';
  reminder = '';
  preDiagnostic = '';
  PoI = '';
  remarks = '';
  analysisDate = '';
  collectionDate = '';
  medForm: MedForm = createEmptyMedForm();
}

export { Metadata };
